module.exports = __webpack_public_path__ + "static/img/phonemobile.4138254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phonemobile.png
// module id = B0Lq
// module chunks = 1